import * as yup from 'yup';

export const phoneMask = [
  /[1-9]/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/
];
export const phoneRegExp = /^[0-9]{3}-[0-9]{3}-[0-9]{4}/;
export const phoneSchema = yup
  .string()
  .matches(phoneRegExp, 'Invalid phone number');
